export default {
  namespaced: true,
  state: {
    options: {
      time_range: [
        // { label: "Lifetime", value: "lifetime" },
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "Last 7 days", value: "last7day" },
        { label: "Last 14 days", value: "last14day" },
        { label: "Last 30 days", value: "last30day" },
        { label: "Month to date", value: "month_to_date" },
        { label: "Last month", value: "last_month" },
        { label: "Quarter to date", value: "quarter_to_date" },
        { label: "Year to date", value: "year_to_date" },
        { label: "Custom Date", value: "custom" },
      ],
    },
    report: {
      headers: [],
      rows: [],
    },
  },
  getters: {},
  mutations: {
    setOptions: (state, data) => {
      state.options = _.assign(state.options, data);
    },
    setReport: (state, data) => {
      state.report.headers = data.headers;
      state.report.rows = data.rows;
    },
  },
  actions: {
    async getOptions({ commit, state }) {
      try {
        let res = await axios.get(`/api/report/options`);
        commit("setOptions", res.data);
      } catch (e) {
        throw e;
      }
    },
    async getReport({ commit, state }, { url, params }) {
      try {
        const res = await axios.post(url, params);
        commit("setReport", res.data);
      } catch (e) {
        throw e;
      }
    },
  },
};
